import { useContext } from "react";
import { LayerContext } from "../contexts";

export function useLayer() {
  const layer = useContext(LayerContext);
  return layer;
}
